module.exports = __webpack_public_path__ + "static/sopimustieto-1a4c732fe6a7b65fa73c6a739aaf106b.jpg";